import { forwardRef } from "react";
import type { SelectProps } from "./interface";

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, children, ...props }, ref) => {
    const hasValue = props.value && props.value !== "" && props.value !== "0";
    
    return (
      <div className="flex flex-col gap-2">
        {label && <label className="font-semibold text-sm">{label}</label>}
        <select
          ref={ref}
          {...props}
          className={`select-component border border-[#D8DCDE] text-sm py-3 px-4 rounded cursor-pointer ${
            hasValue ? "text-black" : "text-[#C2C8CC]"
          }`}
        >
          {children}
        </select>
      </div>
    );
  }
);